// ADD SERVICE BOX OVERLAY ON PRODUCT TILE
const showOverlayServiceBox = function (elm) {

    let overlayActive;
    let $overlayBox;
    let productToAddToCart;
    let errorBoxForAddToCart;
    let cartStoreHasChanged = false;
    let cartTypeHasChanged = false;
    let cartHasStore = false;

    const removeOverlayServiceBox = function () {
        $('.overlayServiceBox:not(.overlayCopy)').remove();
        $('.overlay-min-height').removeClass('overlay-min-height');
        overlayActive = 0;
        $('.product-overlay-captcha-wrapper .product-overlay-captcha').remove();
    }

    const manageOverlayOuterClick = function (overlayBox) {
        $overlayBox = overlayBox[0];
        $(document).on('mousedown', function (event) {
            if (overlayActive && $overlayBox !== event.target && !$overlayBox.contains(event.target)) {
                removeOverlayServiceBox();
                gaPushOnOverlayClose();
            }
        });
    }

    const openOverlayServiceBox = function (productTile, fromSearch) {

        removeOverlayServiceBox();
        let $targetTileTile;
        let $overlayServiceBox = $('.overlayServiceBox');
        let $cloneOverlayServiceBox = $overlayServiceBox.clone();
        let $overlayInputField = $cloneOverlayServiceBox.find('#servicePostalCodeBox');
        // OVERLAY CONDITION - PDP
        if (productTile.hasClass('add-to-cart-pdp') || productTile.hasClass('pdpDetailsContainer')) {
            $targetTileTile = $('.pdpDetailsContainer');
        } else {
            $targetTileTile = productTile.closest('.default-product-tile');
            $targetTileTile.addClass('overlay-min-height');
        }

        // OVERLAY CONDITION - SLIM TILES IN CAROUSEL || AUTO COMPLETE
        let $tileSlimCarousel = $targetTileTile.closest('.tiles--carousel');

        if ($tileSlimCarousel.length) {
            $tileSlimCarousel.closest('.tiles--carousel-container').prepend($cloneOverlayServiceBox);
        } else {
            $targetTileTile.prepend($cloneOverlayServiceBox);
        }

        // SHOW OVERLAY AFTER CLONE
        $cloneOverlayServiceBox.removeClass('overlayCopy hide');
        $cloneOverlayServiceBox.find('.close-overlay-box').focus();

        // CLOSE OVERLAY
        $('.close-overlay-box').on('click', function () {
            removeOverlayServiceBox();
            gaPushOnOverlayClose();
        });

        overlayActive = 1;
        manageOverlayOuterClick($cloneOverlayServiceBox);

        formatServicePostalCode.formatInput($overlayInputField);
        bindButtons();
        bindOverlaySelectService($cloneOverlayServiceBox);

        if (!fromSearch) {
            gaPushOnOverlayView();
        }
    }

    function findServiceByPostalCode($postalCode, targetTileTrigger, errorBox, fromSubmit) {

        if (typeof $postalCode == 'undefined') {
            $postalCode = '';
        }

        let url = displayOverlayProductUrl + '?postalCode=' + $postalCode + '&fromSubmit=' + fromSubmit;
        productToAddToCart = targetTileTrigger;
        errorBoxForAddToCart = errorBox;

        $.ajax({
            url: url,
            type: 'GET',
            contentType: 'application/json',
            dataType: 'html',
            cache: false,
            success: function (data, code, jqXHR) {
                replaceContentOverlay(data, targetTileTrigger, fromSubmit);
            },
            error: function (jqXHR) {
                if (jqXHR.status === 500) {
                    openOverlayServiceBox(targetTileTrigger);
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
                displayErrorOverlay(overlayGenericErrorMsg);
            }
        });

    }

    function createCartAndHandleAssignation(serviceTypeChosen, storeId, deliveryPostalCode, servicePointId, slotId, partnerCode, assignTimeslot, slotFrom, slotTo, slotDeliveryPartner, slotStoreId) {
        let formStateId = $('.overlayServiceBox').data('form-state-id');
        let recaptchaResponse = overlayCaptcha.getResponse();
        $.ajax({
            url: overlayAssignationUrl,
            type: 'POST',
            contentType: 'application/json',
            dataType: 'html',
            data: JSON.stringify({
                'serviceType': serviceTypeChosen,
                'storeId': storeId,
                'deliveryPostalCode': deliveryPostalCode,
                'servicePointId': servicePointId,
                'partnerCode': partnerCode,
                'g-recaptcha-response': recaptchaResponse,
                'formStateId': formStateId,
                'assignTimeslot': assignTimeslot,
                'slot': slotId,
                'slotStoreId': slotStoreId,
                'slotDeliveryPartner': slotDeliveryPartner,
                'slotFrom': slotFrom,
                'slotTo': slotTo
            }),
            cache: false,
            success: function (data, code, jqXHR) {
                cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
                ServiceTimeslot.updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                    cartStoreHasChanged = true;
                }
                if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                    cartTypeHasChanged = true;
                }

                if (typeof serviceType != 'undefined') {
                    serviceType = jqXHR.getResponseHeader('cartServiceType');
                }

                // execute addToCart after overlay is closed
                if (slotId != null) {
                    window['storeId'] = false;
                }

                // update cartWithoutTimeslot variable in JS when page will not be reloaded
                if (assignTimeslot && slotId != null) {
                    ServiceTimeslot.updateCartWithoutTimeslot(false);
                } else {
                    ServiceTimeslot.updateCartWithoutTimeslot(true);
                }

                onCloseOverlayAfterServiceSelection();

                if (isInWebview()) {
                    sendWebviewReloadCartToDevice();
                }
                removeOverlayServiceBox();
            },
            error: function (jqXHR) {
                if (jqXHR.status === 400) {
                    if (jqXHR.getResponseHeader('cartStoreHasChanged') === 'true') {
                        cartStoreHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('cartTypeHasChanged') === 'true') {
                        cartTypeHasChanged = true;
                    }
                    if (jqXHR.getResponseHeader('recaptchaFailed') === 'true') {
                        displayErrorOverlay(overlayRecaptchaErrorMsg);
                        overlayCaptcha.resetCaptcha();
                        return false;
                    }

                    cartHasStore = jqXHR.getResponseHeader('cartHasStore') === 'true';
                    ServiceTimeslot.updateHeaderAfterServiceAndTimeslotRequest(jqXHR);
                    overlayCaptcha.resetCaptcha();
                } else {
                    TINK.redirectIfConflict(jqXHR);
                }
                displayErrorOverlay(overlayGenericErrorMsg);
            }
        });
    }

    function displayErrorOverlay(errorMsg) {
        let $overlayServiceBox = $('.overlayServiceBox:not(.overlayCopy)');
        if (errorMsg) {
            $overlayServiceBox.find('.overlayErrorMsg').text(errorMsg);
        }
        $overlayServiceBox.addClass('error-msg');
    }

    function onCloseOverlayAfterServiceSelection() {
        if (!cartHasStore) {
            window['cartItem'] = null;
        }

        var reloadPageAuthorized = true;
        if (window['cartItem'] && !window['storeId']) {
            window['executeAddProductToCart'](productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, false);
        }

        if (isReloadPageAuthorizedForProductOverlay(reloadPageAuthorized)) {
            reloadPage();
            return;
        }
    }

    function isReloadPageAuthorizedForProductOverlay(reloadPageAuthorized) {
        return (reloadPageAuthorized && cartStoreHasChanged) || (window.location.pathname === shoppingCartUrl);
    }

    function handleCartCreation(assignTimeslot) {
        let $serviceSelected = $('.overlayServiceBox:not(.overlayCopy)').find('.store-to-assign input');
        let $serviceType = $serviceSelected.attr('data-hybris-service-type');
        let $storeId = $serviceSelected.attr('data-store-id');
        let $postalCode = $serviceSelected.attr('data-postal-code');
        let $servicePointId = $serviceSelected.attr('data-service-point-id');
        let $slotId = $serviceSelected.attr('data-slot-id');
        let $slotStoreId = $serviceSelected.attr('data-slot-store-id');
        let $slotFrom = $serviceSelected.attr('data-slot-from');
        let $slotTo = $serviceSelected.attr('data-slot-to');
        let $slotDeliveryPartner = $serviceSelected.attr('data-slot-deliveryPartner');

        createCartAndHandleAssignation($serviceType, $storeId, $postalCode, $servicePointId, $slotId, null, assignTimeslot, $slotFrom, $slotTo, $slotDeliveryPartner, $slotStoreId);
    }

    function bindButtons() {
        let $postalCodeSubmit = $('.overlayServiceBox').find('.postalCode_submit');
        if ($postalCodeSubmit.length) {
            $postalCodeSubmit.prop('disabled', false);
        }
        $postalCodeSubmit.click(function (e) {
            e.preventDefault();
            $(this).prop('disabled', true);

            let $productTileContent;

            if ($('#frequently-bought-together').length && $(this).closest('.item-addToCart').hasClass('productPDP') ) {
                $productTileContent =  $(this).closest('.pdpDetailsContainer');
            } else {
                $productTileContent = $(this).closest('.item-addToCart').find('.pt__content');
            }
            if (!$productTileContent.length) {
                $productTileContent = $(this).closest('.pdpDetailsContainer');
                if (!$productTileContent.length) {
                    $productTileContent = $(this).closest('.overlayServiceBox').parent().find('.item-addToCart .pt__content');
                }
            }
            let $postalCode = $('#servicePostalCodeBox').val();
            findServiceByPostalCode($postalCode, $productTileContent, errorBoxForAddToCart, true);
        });

        $('.overlayServiceBox').find('.openTimeSlotPanel').click(function () {
            let $serviceTypeChoosen = $('.overlayServiceBox:not(.overlayCopy)').find('[name="overlay-select-timeslot"]:checked').data('service-type');
            $(this).prop('disabled', true);
            if ($(this).hasClass('changeTimeslot')) {
                window['changeTimeslot'] = true;
                gaPushOnOverlayClick('change timeslot');
            } else {
                gaPushOnOverlayClick('select timeslot');
            }
            onPanelView('product tile overlay', false);
            ServiceTimeslot.openServiceAndTimeslot.bind(this)(undefined, productToAddToCart.closest('.item-addToCart'), errorBoxForAddToCart, $serviceTypeChoosen);
        });

        $('.overlayServiceBox').find('.chooseLater').click(function () {
            gaPushOnOverlayClick('choose later');
            $(this).prop('disabled', true);
            submitCartCreation();
        });

        $('.overlayServiceBox').find('.reserve-timeslot').click(function () {
            gaPushOnOverlayClick('reserve timeslot');
            $(this).prop('disabled', true);
            handleCartCreation(true);
        });
    }

    function bindOverlaySelectService(overlayServiceBox) {
        overlayServiceBox.find('[name="overlay-select-timeslot"]').change(function () {
            let $storeToAssign = $('.overlayServiceBox:not(.overlayCopy)').find('.store-to-assign input');
            $storeToAssign.data('hybris-service-type', $(this).data('hybris-service-type'));
            $storeToAssign.data('store-id', $(this).data('store-id'));
            $storeToAssign.data('postal-code', $(this).data('postal-code'));
            if ($(this).data('service-point-id')) {
                $storeToAssign.data('service-point-id', $(this).data('service-point-id'));
            } else {
                $storeToAssign.removeAttr('data-service-point-id');
            }
        });
    }

    function bindCaptcha() {
        overlayCaptcha.removeCaptcha();
        overlayCaptcha.renderCaptcha();
    }

    function submitCartCreation() {
        if (overlayCaptcha.isEnabledAndInvisible()) {
            overlayCaptcha.executeCaptcha();
        } else {
            handleCartCreation(false);
        }
    }

    window['executeOverlayCartCreation'] = function () {
        handleCartCreation(false);
    }

    function replaceContentOverlay(data, targetTileTrigger, fromSearch) {
        data = data.trim();
        let $overlay = $('.overlayServiceBox.overlayCopy.hide');
        $overlay.replaceWith(data);
        openOverlayServiceBox(targetTileTrigger, fromSearch);

        let $activeOverlay = $('.overlayServiceBox:not(.overlayCopy)');

        let $overlayRecaptcha = $('.product-overlay-captcha');
        let $overlayRecaptchaWrapper = $('.product-overlay-captcha-wrapper');
        if ($overlayRecaptcha.length && $overlayRecaptchaWrapper.length) {
            $overlayRecaptchaWrapper.append($overlayRecaptcha).ready(bindCaptcha);
        }

        if (data !== '') {
            $('#servicePostalCodeBox').focus();

            let serviceDisabled = $activeOverlay.find('.box__select-service input[disabled]').length;
            let postalCodeValue = $('#servicePostalCodeBox').val();
            if (typeof postalCodeValue != 'undefined' && postalCodeValue.length != 0 && serviceDisabled >= 2) {
                $activeOverlay.find('.box__select-service').addClass('hide');
                $activeOverlay.find('.service-box_postal-actions').addClass('hide');
                $activeOverlay.find('.alert-no-service').removeClass('hide');
            }
        }
    }

    return {
        removeOverlayServiceBox: removeOverlayServiceBox,
        openOverlayServiceBox: openOverlayServiceBox,
        findServiceByPostalCode: findServiceByPostalCode
    }
}();